var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    stroke: "#9DA1B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 3.22687C11.7618 3.00358 12.2382 3.00358 12.625 3.22687L19.2853 7.07217C19.672 7.29546 19.9103 7.70812 19.9103 8.1547V15.8453C19.9103 16.2919 19.672 16.7045 19.2853 16.9278L12.625 20.7731C12.2382 20.9964 11.7618 20.9964 11.375 20.7731L4.71475 16.9278C4.32799 16.7045 4.08975 16.2919 4.08975 15.8453V8.1547C4.08975 7.70812 4.32799 7.29546 4.71475 7.07217L11.375 3.22687Z",
    stroke: "#9DA1B5",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a88c17e7ccbab4df3efb169e3b760690.svg";
export { ForwardRef as ReactComponent };